//import Libraries
import React, {Component} from 'react';
import * as axios from 'axios';
import {storageRef} from '../../../../firebase';

//import Components

//import Style classes
import './BlogCard.css';

class BlogCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            text : '',
            url : ''
        }
    }

    componentDidMount() {
        this.loadHTMLContent();
        this.loadImageFromStorage();
    }

    loadHTMLContent = () => {
        const articleRef = storageRef.child(`articles/${this.props.data.id}.html`);
        articleRef.getDownloadURL()
            .then((url) => {
                axios.get(url, {
                })
                    .then((res) => {
                        this.setState({
                            text : res.data
                        })
                    })
                    .catch((e)=>{
                    })
            })
            .catch((e) => {
            })
    }

    loadImageFromStorage = () => {
        const articleImageRef = storageRef.child(`article_images/${this.props.data.id}_0.jpg`);
        articleImageRef.getDownloadURL()
            .then((url) => {
                this.setState({
                    url
                })
            })
            .catch((e) => {
            })
    }

    render() {
        return (
            <div className="BlogCard" onClick={this.props.onClick}>
                <div className="BackgroundImage">
                    <img src={this.state.url} alt="" />
                </div>
                <div className="Content">
                    <h3>{this.props.data.title}</h3>
                    <p>
                        {this.props.data.subTitle}
                    </p>
                </div>
            </div>
        )
    }
}


export default BlogCard;



// WEBPACK FOOTER //
// ./src/pages/Community/Blog/BlogCard/BlogCard.js